<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    viewBox: '0 0 44 40',
    color: '#FBBA13',
  }
);

const originalWidth = 44;
const originalHeight = 40;
const aspectRatio = originalWidth / originalHeight;

const computedWidth = computed(() => {
  if (props.width) return props.width;
  if (props.height) return props.height * aspectRatio;
  return originalWidth;
});

const computedHeight = computed(() => {
  if (props.height) return props.height;
  if (props.width) return props.width / aspectRatio;
  return originalHeight;
});
</script>

<template>
  <svg
    :width="computedWidth"
    :height="computedHeight"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.6565 30.1562C19.6565 30.7779 19.9034 31.374 20.343 31.8135C20.7825 32.2531 21.3786 32.5 22.0002 32.5C22.6218 32.5 23.218 32.2531 23.6575 31.8135C24.0971 31.374 24.344 30.7779 24.344 30.1562C24.344 29.5346 24.0971 28.9385 23.6575 28.499C23.218 28.0594 22.6218 27.8125 22.0002 27.8125C21.3786 27.8125 20.7825 28.0594 20.343 28.499C19.9034 28.9385 19.6565 29.5346 19.6565 30.1562ZM20.4377 15.3125V24.2969C20.4377 24.5117 20.6135 24.6875 20.8284 24.6875H23.1721C23.387 24.6875 23.5627 24.5117 23.5627 24.2969V15.3125C23.5627 15.0977 23.387 14.9219 23.1721 14.9219H20.8284C20.6135 14.9219 20.4377 15.0977 20.4377 15.3125ZM43.6653 36.7969L23.3528 1.64062C23.05 1.11816 22.5276 0.859375 22.0002 0.859375C21.4729 0.859375 20.9456 1.11816 20.6477 1.64062L0.335222 36.7969C-0.265364 37.8418 0.486588 39.1406 1.68776 39.1406H42.3127C43.5139 39.1406 44.2659 37.8418 43.6653 36.7969ZM5.40846 35.4346L22.0002 6.71387L38.592 35.4346H5.40846Z"
      :fill="props.color"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
